document.addEventListener("DOMContentLoaded", function () {
    console.log("🔵 Quick Buy modal script initialized.");

    document.querySelectorAll('.quick-buy-modal .variant-picker__option-values a').forEach(function (swatch) {
        swatch.addEventListener('click', function (e) {
            console.log("🟠 Swatch clicked:", this);

            // 🚨 Fix: Prevent navigation in Firefox and Safari
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            console.log("✅ e.preventDefault(), stopPropagation(), and stopImmediatePropagation() applied");

            // 🚨 Fix: Temporarily remove href to prevent navigation
            const originalHref = this.getAttribute('href');
            this.removeAttribute('href');
            console.log("🚨 Temporarily removed href to prevent navigation in Firefox");

            document.querySelectorAll('.quick-buy-modal .variant-picker__option-values a').forEach(function (swatchColor) {
                swatchColor.classList.remove('is-selected');
            });

            this.classList.add('is-selected');

            const productUrl = originalHref; // Use saved href

            if (!productUrl) {
                console.error("❌ No product URL found on swatch:", this);
                return;
            }

            console.log("🔵 Fetching product data from:", productUrl);

            fetch(productUrl + '.js')
                .then((response) => {
                    console.log("🔵 Fetch response status:", response.status);
                    if (!response.ok) {
                        throw new Error(`❌ HTTP error! Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((product) => {
                    console.log("🟢 Product fetched successfully:", product);

                    if (!product.variants || product.variants.length === 0) {
                        console.error("❌ No variants found for product:", product);
                        return;
                    }

                    updateQuickBuyModal(product);
                    updateSizePicker(product);
                    updateAddToCartForm(product.variants[0].id, product.id);

                    // ✅ Restore href after data loads
                    this.setAttribute('href', originalHref);
                    console.log("✅ Restored href after data load");
                })
                .catch((error) => {
                    console.error("❌ Error fetching product data:", error);
                    // 🔥 Ensure href is restored even if there's an error
                    this.setAttribute('href', originalHref);
                });
        });
    });
});
